<template>
  <div class="freez-action-col" :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    	<a
      @click="goToSessionDetailedView(params.id,params.name)"
      class="text-center" title="View Details">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24px"
        height="24px"
        viewBox="0 0 30 12"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class
      >
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
        <circle cx="12" cy="12" r="3" />
      </svg>
    </a>
  </div>
</template>

<style scoped>
/*.switch-publish {
}*/
</style>
<script>
export default {
  name: "SessionViewCellRendererActions",
  data: {
    //IsPublished: false
  },
  watch: {
  },
  methods: {
    goToSessionDetailedView(id,name) {
          this.$router
        .push({
          name: "session-view-details",
          params: {
            sessionId: id,
            sessionName: name
          }
        })
        .catch(() => {});
    },
  }
};
</script>
